// eslint-disable-next-line import/no-cycle
import api from '@src/api';
import { Observable } from 'rxjs';
import { Action } from 'redux-actions';

export const getRegistrationLinkStatus = (id: string): Observable<Action> => (
	api.get(`registration-links/${id}/status`)
);

type PostCreateRegistrationEmailUserPayload = {
	email: string;
	first_name: string;
	last_name: string;
	verification_code: string
}

export const postCreateRegistrationEmailUser = (
	id: string,
	form: PostCreateRegistrationEmailUserPayload,
): Observable<Action> => (
	api.post(`registration-links/${id}/create-user`, form)
);

type PostCreateRegistrationMobileUserPayload = {
	dialing_code: string;
	first_name: string;
	last_name: string;
	mobile_number: string;
	verification_code: string;
}

export const postCreateRegistrationMobileUser = (
	id: string,
	form: PostCreateRegistrationMobileUserPayload,
): Observable<Action> => (
	api.post(`registration-links/${id}/create-mobile-user`, form)
);

export const postRegisterRegistrationLinkUser = (
	id: string,
	form: Record<string, unknown>,
): Observable<Action> => (
	api.post(`registration-links/${id}/register-user`, form)
);

export const postRegistrationLinkLoginVerify = (
	form: { code: string },
): Observable<Action> => (
	api.post('registration-links/login/verify', form)
);
